module.exports = __webpack_public_path__ + "components/forecast-table/tooltips/static/snowfall-d43891fca747361f7c5e828e8fa72b90.jpg";